<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">관심사</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">프로필에 표시해놓고 싶은 관심분야<br>한 가지를 선택할 수 있습니다.</div>
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-top: 40px;">
                    <div @click="setDisplayTag(each)" :class="selectDisplayTag === each ? 'active' : ''" v-for="each, i in displayTagList" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                        {{ each }}
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectDisplayTag !== ''" class="save_btn_active">저장하기</div>
                <div v-else @click="save" class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingDisplayTag',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectDisplayTag: '',
            displayTagList: ['국내축구', '해외축구', '월드컵', '축구공', '축구화', '축구 기술', '축구선수', '피지컬', '축구 유튜버', '이적 시장', '축구 경기', '축구 이슈', '축구 경기 관람', '축구 밈/유머'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setDisplayTag(tag) {
            this.selectDisplayTag = tag
        },
        async save() {
            if (this.selectDisplayTag === '') {
                this.$GlobalStore.showAlert('관심사를 선택 해주세요.');
                return;
            }
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('use_reasons', this.selectDisplayTag)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectDisplayTag = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectDisplayTag = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>